export const links = [
    {
        id: 'all',
        title: 'Все кейсы',
        href: '/cases',
    },
    {
        id: 'development',
        title: 'разработка',
        href: '/cases/development',
    },
    {
        id: 'marketing',
        title: 'маркетинг',
        href: '/cases/marketing',
    },
    {
        id: 'products',
        title: 'продукты',
        href: '/cases/products',
    },
];

type ProjectType = {
    router: string;
    newImg?: string;
    video?: string;
    title: string;
    description: string;
    keys: string[];
    id: string;
    titlesNew?: { title: string }[];
};

const newCase = 'новый кейс';

export type ListNewProjectsType = ProjectType[];
export //keys - принимает 4 ключа: all, marketing, development, products = привет typescript
const listNewProjects = [
    {
        newImg: '/images/jpg/dobro/banner_dobro_image.jpg',
        oldImg: '/images/jpg/dobro/banner_dobro_image.jpg',
        router: '/cases/development/dobro',
        video: '/video/video/case-video/dobro-case-video.MOV',
        title: 'Перезапустили платформу Добро.рф',
        description:
            'Разработали 5 новых сервисов, переработали пользовательский опыт, расширили ' +
            'коммуникационную инфраструктуру и выстроили технологическую основу для дальнейшего роста экосистемы.',
        keys: ['development'],
        titlesNew: [{ title: newCase }],
        id: '43',
    },
    {
        router: '/cases/development/rgs',
        newImg: '/images/pic/cases-list-images/rgs.jpg',
        oldImg: '/images/pic/cases-list-images/rgs.jpg',
        video: '/video/videoRgs.mp4',
        title: '14&nbsp;интеграций, новый личный кабинет и&nbsp;одна цель',
        description:
            'Как мы&nbsp;помогли &laquo;Росгосстраху&raquo; совершить технологическую трансформацию',
        keys: ['development'],
        id: '2',
    },
    {
        newImg: '/images/pic/cases-list-images/vk-tech.png',
        router: '/cases/marketing/vk-tech',
        video: '/video/mp4/vk-tech/vk-tech.mp4',
        title: 'Эволюция brandformance-модели VK Tech',
        description:
            'За четыре месяца снизили стоимость на подключение B2B-сервисов на 51%, ' +
            'уменьшили цену SQL-лида на 41% и на 6,7 процентных пункта сократили долю рекламных ' +
            'расходов за счет объединения бренда и перформанс в единую архитектуру.',
        keys: ['marketing'],
        titlesNew: [{ title: 'новый кейс' }],
        id: '45',
    },
    {
        router: '/cases/marketing/renessans-bank',
        newImg: '/images/pic/cases-list-images/renessans-bank.png',
        video: '/video/renessans.mp4',
        title: 'SEO для Ренессанс Банка',
        description:
            'Увеличили на 22% продажи банковских продуктов за счет продуманной структуры, правильного ' +
            'контента и системы внешней оптимизации сайта',
        keys: ['development', 'marketing'],
        titlesNew: [{ title: newCase }],
        id: '41',
    },
    {
        router: '/cases/development/pochtabank',
        newImg: '/images/pic/cases-list-images/pochtabank.jpg',
        oldImg: '/images/svg/projects/projects__img20.png',
        video: '/video/videoPochtabank.mp4',
        icons: [
            {
                icon: '/images/svg/cases-list-icons/pochta.svg',
                width: 204,
                height: 48,
            },
            { icon: '/images/svg/cases-list-icons/awardStarsPochta.svg', width: 152, height: 48 },
        ],

        title: 'Новый сайт для Почта Банка',
        description:
            // eslint-disable-next-line max-len
            'Перенесли сайт на&nbsp;новую платформу с&nbsp;облачной архитектурой и&nbsp;создали конструктор для управления контентом',
        keys: ['development'],
        id: '4',
    },
    {
        router: '/cases/development/talent-mind',
        newImg: '/images/svg/cases-list-icons/talent-mind-case.png',
        video: '/video/talent-mind-video.mp4',
        title: 'TalentMind — ИИ\u2011платформа для скоринга софт-скилов',
        description:
            // eslint-disable-next-line max-len
            'Позволит компаниям объективно оценивать софт-скилы кандидатов по записям интервью. В 9 раз сокращает время анализа и на 80% ускоряет принятие решений.',
        keys: ['development', 'products'],
        titlesNew: [{ title: newCase }],
        id: '42',
        icons: [
            {
                icon: '/images/svg/cases-list-icons/tagline-award-talent-mind.svg',
                width: 154,
                height: 48,
            },
        ],
    },
    {
        newImg: '/images/pic/cases-list-images/data-fusion.png',
        router: '/cases/marketing/data-fusion',
        video: '/video/mp4/data-fusion/Datafusion.mp4',
        title: 'Перформанс-маркетинг для ИТ-соревнования Data Fusion Contest',
        description:
            'За 6 недель привлекли 1 540 регистраций на международные\n' +
            'ML-соревнования за&nbsp;счет тестирования гипотез, мультиканальной стратегии и' +
            'использования креатива как полноценного performance-инструмента',
        keys: ['marketing'],
        titlesNew: [{ title: 'новый кейс' }],
        id: '44',
    },
    {
        newImg: '/images/pic/cases-list-images/dobro-ui.png',
        router: '/cases/development/dobro-ui',
        video: '/video/mp4/dobro-ui/dobro-ui.mp4',
        title: 'Пересобрали дизайн-систему для Добро.рф',
        description:
            'Построили новую дизайн-систему для экосистемы сервисов на основе токенной модели ' +
            'для централизованного управления элементами интерфейса. В результате время ' +
            'на внедрение дизайна в код сократилось на 45%',
        keys: ['development'],
        titlesNew: [{ title: 'новый кейс' }],
        id: '46',
    },
    {
        router: '/cases/marketing/moscow-exchange',
        newImg: '/images/pic/cases-list-images/moscow-exchange-small.png',
        oldImg: '',
        video: '/video/videoMoscowExchange.mp4',
        icons: [{ icon: '/images/svg/cases-list-icons/ruward.svg', width: 84, height: 48 }],

        // eslint-disable-next-line sonarjs/no-duplicate-string
        title: 'Увеличили трафик в&nbsp;4&nbsp;раза для сайтов Московской биржи за&nbsp;5&nbsp;месяцев',
        description:
            'Рост трафика в&nbsp;4&nbsp;раза для сайтов finuslugi.ru и&nbsp;moex.com по&nbsp;приоритетным направлениям',
        keys: ['marketing'],
        id: '1',
    },
    {
        router: '/cases/marketing/t1/',
        newImg: '/images/pic/cases-list-images/t1.png',
        video: '/video/banner.mp4',
        title: 'Привлекли 8000+ кандидатов узких специальностей в ИТ-холдинг Т1\n',
        description:
            // eslint-disable-next-line max-len
            'Реализовали масштабную перформанс-кампанию для карьерно-образовательного проекта ' +
            'и усилили HR-бренд крупнейшей ИТ-компании страны',
        keys: ['marketing'],
        id: '39',
    },
    {
        router: '/cases/development/frt-service',
        newImg: '/images/pic/cases-list-images/frt-service.jpg',
        video: '/video/videoFrtService.mp4',
        title: 'Сервис для обманутых дольщиков на&nbsp;Госуслугах',
        description: 'Интегрировали сервис для облегчения получения компенсаций на&nbsp;госпортал',
        keys: ['development'],
        id: '5',
    },
    {
        router: '/cases/development/vetas/',
        newImg: '/images/pic/cases-list-images/vetas.jpg',
        video: '/video/vitas.mp4',
        title: 'ИИ-ассистент для ветеринаров: победить рутину и спасти животных\n',
        description:
            // eslint-disable-next-line max-len
            'Первый в России ИИ-ассистент, который помогает ветеринарам оформлять протоколы инструментальных исследований голосом, сокращая время на рутину и повышая точность данных.',
        keys: ['development', 'products'],
        id: '40',
    },

    {
        router: '/cases/development/skills-team',
        newImg: '/images/pic/cases-list-images/skillsPoster.jpg',
        oldImg: '',
        video: '/video/videoSkillsTeam.mp4',
        icons: [
            {
                icon: '/images/svg/cases-list-icons/awardSkills.svg',
                width: 208,
                height: 48,
            },
        ],
        title: 'SkillsTeam',
        description: 'Российская система управления грейдами',
        keys: ['development', 'products'],
        id: '3',
    },
    {
        router: '/cases/development/teboil',
        newImg: '/images/pic/cases-list-images/teboil.jpg',
        video: '/video/videoTeboil.mp4',
        title: 'Разработка e‑commerce проекта для&nbsp;бренда Teboil',
        description:
            // eslint-disable-next-line max-len
            'За&nbsp;4&nbsp;месяца разработали интернет-магазин для&nbsp;производителя автомобильных масел, интегрировав его с&nbsp;несколькими внешними системами',
        keys: ['development'],
        id: '7',
    },
    {
        router: '/cases/marketing/sk10',
        newImg: '/images/pic/ck10/ck10.png',
        video: '/video/SK10.mp4',
        icons: [
            {
                icon: '/images/svg/cases-list-icons/sk10.svg',
                width: 204,
                height: 48,
            },
        ],
        title: 'Лидогенерация в&nbsp;недвижимости: привлекли 4600 лидов на&nbsp;покупку квартир',
        description:
            // eslint-disable-next-line max-len
            'Выстроили устойчивую систему получения лидов за&nbsp;счет тестирования гипотез: в&nbsp;5&nbsp;раз снизили стоимость лида и&nbsp;в&nbsp;3&nbsp;раза увеличили их&nbsp;объём.',
        keys: ['marketing'],
        id: '8',
    },
    {
        router: '/cases/development/new-rec',
        newImg: '/images/pic/new-rec/rec.jpg',
        video: '/video/osumk.mp4',
        title: 'Омниканальная система коммуникаций для Российского экспортного центра',
        description:
            // eslint-disable-next-line max-len
            'Внедрили в&nbsp;работу Российского экспортного центра омниканальную систему маркетинговых коммуникации, которая позволяет автоматизировать взаимодействие с&nbsp;пользователями портала &laquo;Мой экспорт&raquo;.',
        keys: ['development'],
        id: '9',
    },
    {
        router: '/cases/marketing/bonum',
        newImg: '/images/pic/cases-list-images/bonum.jpg',
        video: '/video/videoBonum.mp4',
        title: 'Увеличили продажи спецтехники: кейс завода Bonum',
        description:
            // eslint-disable-next-line max-len
            'Снизили стоимость конверсий за счет распределения рекламного трафика по&nbsp;каналам и постоянного тестирования гипотез',
        keys: ['marketing'],
        id: '18',
    },

    {
        router: '/cases/development/aimed',
        newImg: '/images/pic/aimed/aimed.png',
        video: '/video/case-aimed.mp4',
        title: 'Платформа для диагностики пациентов с&nbsp;помощью&nbsp;ИИ',
        description:
            // eslint-disable-next-line max-len
            'Разработали высоконагруженную платформу для конкурсов AI&rsquo;m Finder и&nbsp;AI&rsquo;m Doctor и&nbsp;сформировали уникальные датасеты для обучения российских ИИ-систем, которые станут основой системы поддержки принятия врачебных решений.',
        keys: ['development'],
        id: '6',
    },

    {
        router: '/cases/marketing/felix',
        newImg: '/images/pic/cases-list-images/felix.png',
        oldImg: '',
        video: '/video/videoFelix.mp4',
        title: 'Увеличили на 230% количество подписчиков для бренда FELIX',
        description:
            'Создали активное комьюнити, повысили лояльность к продукции компании «Тосол-Синтез» ' +
            'в социальных сетях за счет вовлекающего контента, спецформатов и четкой стратегии продвижения',
        keys: ['marketing'],
        id: '10',
    },
    {
        router: '/cases/development/fondrt',
        newImg: '/images/pic/cases-list-images/fondrt.jpg',
        video: '/video/videoFrt.mp4',
        title: 'Развитие сайта Фонда развития территорий',
        description:
            'Усовершенствовали онлайн-сервисы для дольщиков и&nbsp;интегрировали сайт с&nbsp;порталом Госуслуг',
        keys: ['development'],
        id: '11',
    },
    {
        router: '/cases/marketing/skolkovo',
        oldImg: '/images/svg/projects/projects__img3.png',
        newImg: '/images/pic/cases-list-images/skolkovo12.jpg',
        video: '/video/videoSkolkovo.mp4',
        title: 'Технопарк «Сколково»',
        description:
            // eslint-disable-next-line max-len
            'Одновременно продвигали 12&nbsp;проектов и&nbsp;выполнили 100% KPI по&nbsp;каждому за&nbsp;счет точной сегментации и&nbsp;таргетинга',
        keys: ['marketing'],
        id: '12',
    },
    {
        router: '/cases/marketing/otp-bank',
        newImg: '/images/pic/cases-list-images/otpbank.jpg',
        video: '/video/video/videoOtpbank.mp4',
        title: 'Узкие ключи и&nbsp;контентное SEO: кейс ОТП&nbsp;Банка',
        description:
            // eslint-disable-next-line max-len
            'Увеличили небрендовый поисковый трафик по&nbsp;ключевым банковским услугам и&nbsp;добились высоких позиций в&nbsp;выдаче',
        keys: ['marketing'],
        id: '13',
    },
    {
        router: '/cases/marketing/avenu',
        newImg: '/images/svg/projects/projects__img22.png',
        video: '/video/video/videoAvenu.mp4',
        title: 'Сеть медицинских центров АВЕНЮ',
        description: 'Контекстная реклама для медицинских центров АВЕНЮ',
        keys: ['marketing'],
        id: '14',
    },
    {
        router: '/cases/development/dev-rec/',
        newImg: '/images/pic/cases-list-images/rosexpocenter.jpg',
        video: '/video/video/videoExpocenter.mp4',
        title: 'РЭЦ',
        description:
            // eslint-disable-next-line max-len
            'Модернизация сайта и&nbsp;внутреннего портала со&nbsp;сложной архитектурой и&nbsp;круглосуточная техническая поддержка',
        keys: ['development'],
        id: '15',
    },
    {
        router: '/cases/development/gapresource',
        newImg: '/images/pic/cases-list-images/gapresurs.jpg',
        video: '/video/video/videoGapresurs.mp4',
        title: 'Мультиязычный сайт для агрохолдинга &laquo;Ресурс&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Спроектировали функциональный и&nbsp;адаптивный корпоративный сайт на&nbsp;4&nbsp;языках с&nbsp;возможностями SEO-продвижения',
        keys: ['development'],
        id: '16',
    },
    {
        router: '/cases/development/rukami/',
        newImg: '/images/pic/cases-list-images/rukami.jpg',
        video: '/video/video/videoRukami.mp4',
        icons: [{ icon: '/images/svg/cases-list-icons/rukami.svg', width: 220, height: 48 }],
        title: 'Международный киберфестиваль RUKAMI',
        description:
            // eslint-disable-next-line max-len
            'Разработали интерактивную highload-платформу и&nbsp;обеспечили бесперебойную работу для 100 тысяч пользователей',
        keys: ['development'],
        id: '17',
    },

    {
        router: '/cases/marketing/seo-fintech',
        newImg: '/images/pic/cases-list-images/seofintech.jpg',
        video: '/video/video/videoFintech.mp4',
        title: 'SEO для финтеха',
        description:
            'Типичные ошибки и&nbsp;практические советы по&nbsp;поисковой оптимизации сайтов финансовых компаний',
        keys: [] as string[],
        id: '19',
    },
    {
        router: '/cases/marketing/medved',
        newImg: '/images/pic/cases-list-images/medved.jpg',
        title: 'Медведь',
        video: '/video/video/videoMedved.mp4',
        description: 'SEO для интернет-магазина спортивных товаров',
        keys: ['marketing'],
        id: '20',
    },
    {
        router: '/cases/marketing/garantiinyi-fond',
        newImg: '/images/pic/cases-list-images/garantfond.jpg',
        title: 'Контент-маркетинг для Гарантийного фонда Ростовской области',
        description: 'SMM-стратегия для продвижения сообществ клиента из&nbsp;госсектора',
        keys: ['marketing'],
        id: '21',
    },
    {
        router: '/cases/products/2pdf/',
        oldImg: '/images/svg/projects/projects__img10.png',
        title: '2pdf.com',
        video: '/video/video/video2pdf.mp4',
        description:
            'Создание и&nbsp;запуск высоконагруженного сервиса для конвертации pdf-файлов на&nbsp;международный рынок',
        keys: ['products'],
        id: '22',
    },
    {
        router: '/cases/development/upgreat/',
        newImg: '/images/pic/cases-list-images/ai.png',
        title: 'Платформа для конкурса по&nbsp;разработке искусственного интеллекта',
        video: '/video/video/aiPlatform.mp4',
        description:
            // eslint-disable-next-line max-len
            'Разработали и&nbsp;запустили высокотехнологичную платформу для&nbsp;конкурса Up&nbsp;Great ПРО//ЧТЕНИЕ с&nbsp;открытым кодом',
        keys: ['development'],
        id: '23',
    },
    {
        router: '/cases/marketing/yookassa',
        newImg: '/images/pic/cases-list-images/ukassa.jpg',
        title: 'Юкасса',
        description: 'Сохранить небрендовый трафик и&nbsp;минимизировать потери позиций сайта',
        keys: [] as string[],
        id: '24',
    },
    {
        router: '/cases/marketing/skolkovo-kids',
        newImg: '/images/pic/cases-list-images/skolkovodeti.jpg',
        title: 'Дети в&nbsp;Сколково',
        video: '/video/skolkovodeti.mp4',
        description: 'Как сделать сообщество эффективной площадкой для бренда',
        keys: ['marketing'],
        id: '25',
    },
    {
        router: '/cases/marketing/nanoteh/',
        oldImg: '/images/svg/projects/projects__img11.png',
        title: 'Двукратный рост трафика и&nbsp;видимости сайта РМ&nbsp;&laquo;Нанотех&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Увеличили посещение сайта в&nbsp;2&nbsp;раза и&nbsp;вывели более 1000 фраз из&nbsp;узкой семантики в&nbsp;топ-10 за&nbsp;6&nbsp;месяцев',
        keys: ['marketing'],
        id: '26',
    },
    {
        router: '/cases/development/gge/',
        oldImg: '/images/svg/projects/projects__img13.png',
        title: 'Улучшение сайта Главгосэкспертизы России',
        description:
            // eslint-disable-next-line max-len
            'Провели масштабные работы по&nbsp;переносу проекта на&nbsp;новый сервер, создали новые и&nbsp;доработали старые функции сайта',
        keys: ['development'],
        id: '27',
    },
    {
        router: '/cases/products/converter/',
        oldImg: '/images/svg/projects/projects__img2.png',
        title: 'Onlineconvertfree.com',
        description: 'Создали платформу мирового уровня для&nbsp;онлайн-конвертации 250+ форматов',
        keys: ['products'],
        id: '28',
    },
    {
        router: '/cases/development/techleaders/',
        oldImg: '/images/svg/projects/projects__img6.png',
        title: 'Экосистема форума «Глобальное технологическое лидерство»',
        description:
            // eslint-disable-next-line max-len
            'Развернули сложную экосистему на&nbsp;сайте форума с&nbsp;интеграцией технологических инструментов для моментальной передачи информации',
        keys: ['development'],
        id: '29',
    },
    {
        router: '/cases/development/letovo/',
        oldImg: '/images/svg/projects/projects__img14.png',
        title: 'Модернизация сайта международной школы &laquo;Летово&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Сделали 7&nbsp;сложных интеграций, обновили дизайн, модернизировали личный кабинет, разработали и&nbsp;запустили англоязычную версию сайта',
        keys: ['development'],
        id: '30',
    },
    {
        router: '/cases/development/zkhfoundation/',
        oldImg: '/images/svg/projects/projects__img12.png',
        title: 'Комплексное обновление бренда Фонда ЖКХ ',
        description:
            // eslint-disable-next-line max-len
            'Заменили систему управления сайтом и&nbsp;разработали новый брендбук для&nbsp;коммуникационных материалов по&nbsp;ключевым направлениям Фонда',
        keys: ['development'],
        id: '31',
    },
    {
        router: '/cases/marketing/mid/',
        oldImg: '/images/svg/projects/projects__img15.png',
        title: 'Привлечение абитуриентов в&nbsp;колледж через онлайн-каналы',
        description:
            // eslint-disable-next-line max-len
            'Помогли колледжу МИД России собрать в&nbsp;3&nbsp;раза больше заявок на&nbsp;поступление с&nbsp;помощью таргета и&nbsp;контекста с&nbsp;охватом более 1,5 млн человек',
        keys: ['marketing'],
        id: '32',
    },
    {
        router: '/cases/marketing/adventureland/',
        oldImg: '/images/svg/projects/projects__img18.png',
        title: 'Продвижение сообщества AdventureLand Технопарка &laquo;Сколково&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Провели эффективные рекламные кампании по&nbsp;привлечению стартапов и&nbsp;инвесторов в&nbsp;крупнейший технопарк Европы',
        keys: ['marketing'],
        id: '33',
    },
    {
        router: '/cases/products/linkbuilder/',
        oldImg: '/images/svg/projects/projects__img1.png',
        title: 'Linkbuilder.Ai',
        description:
            'Автоматический сервис по&nbsp;увеличению ссылочной массы для владельцев бизнеса',
        keys: ['products'],
        id: '34',
    },
    {
        router: '/cases/marketing/mts-invest/',
        newImg: '/images/svg/projects/projects__img8.png',
        title: 'МТС Инвестиции',
        description: 'Техническая и поисковая оптимизация страниц сайта',
        keys: ['marketing'],
        id: '35',
    },
    {
        router: '/cases/development/krdv/',
        oldImg: '/images/svg/projects/projects__img9.png',
        title: 'Корпорация развития Дальнего Востока',
        description: 'Разработка инновационных сервисов для&nbsp;системы личных кабинетов',
        keys: ['development'],
        id: '36',
    },
    {
        router: '/cases/development/gens/',
        oldImg: '/images/svg/projects/projects__img4.png',
        title: 'Акселератор «GenerationS»',
        description: 'Cоздание платформы для проведения отбора в&nbsp;корпоративные акселераторы',
        keys: ['development'],
        id: '37',
    },
    {
        router: '/cases/marketing/rec/',
        oldImg: '/images/svg/projects/projects__img5.png',
        title: 'Российский экспортный центр',
        description:
            // eslint-disable-next-line max-len
            'С&nbsp;помощью контекстной рекламы и&nbsp;поисковой оптимизации повысить охват и&nbsp;рост целевого трафика',
        keys: ['marketing'],
        id: '38',
    },
];
